import {t} from '@eitje/bridge'
import {Title} from '../../../text'
import {Layout} from '../../../layout'
import {useFilterContext} from '../../../filters'

// Below is a much simplified version of the earlier implementation which also printed the environment
// names which were set by the Filters. If we want to reroll this or reuse that logic for another
// purpose, simply browse this file's commit history.

export const PageHeaderTitle = ({label, pageHeaderSkipCount}) => {
	const {items, pageHeaderItemsCount} = useFilterContext()

	let amount = items ? items.length : ''
	if (pageHeaderItemsCount) amount = pageHeaderItemsCount(items)
	amount = pageHeaderSkipCount ? '' : `${amount} `

	const title = amount + t(label)

	return (
		<Layout className="page-header-title">
			<Title semiBold truncate>
				{title}
			</Title>
		</Layout>
	)
}
